import { safePath } from './safePath.js'

// P7 P2 (TEST 2.09) — where a profile subpage goes back to after Save.
//
// ★★★ THE DEFECT THIS EXISTS FOR. DeliverScreen's reopen flow sends the patient to
//   /profile/insurance, /profile/allergies and /profile/medications to update something
//   before sending a follow-up request. Each subpage's Save hard-coded `navigate('/profile')`
//   — so the patient landed on the Profile tab, not back in the middle of the reopen flow
//   they came from, and the in-progress date/time/visit-type/notes/photos draft was gone.
//
// ★★ Router state only, never sessionStorage: a WKWebView content-process recycle drops
//   sessionStorage (the exact TF b34 #13/#17 shape check-auth-storage guards elsewhere), and
//   this draft is not worth a persistence layer — it only needs to survive one navigation.
//
// A `returnTo` that is not a same-app CASE route is refused (`/profile` instead): an open
// redirect target, or a stale/foreign path, is not honoured — only `/case...` is a route
// this app itself sent the patient away FROM.
export function resolveProfileReturn(locationState) {
  // PROD-1313: safePath also refuses a backslash, a "//" or a scheme after the "/case" prefix.
  const returnTo = safePath(locationState?.returnTo, '')
  if (returnTo.startsWith('/case')) {
    return { path: returnTo, state: locationState?.returnState }
  }
  return { path: '/profile', state: undefined }
}
